module.exports = __webpack_public_path__ + "static/Siegfried-Alberton-f8e2e415bbb948f7ca145f4b07fd5ae9.jpg";